const checkUrl = (url?: string): string => {
  if (url) {
    let checkedUrl = url
    if (checkedUrl.search('http') === -1) {
      checkedUrl = `http://${url}`
    }
    return checkedUrl
  } else {
    return ''
  }
}

export default checkUrl
